import { useContext } from 'react'

import {
  ActionPanelContext,
  type ActionPanelContextValue,
} from './ActionPanelContext'

export const useActionPanel = (): ActionPanelContextValue => {
  const ctx = useContext(ActionPanelContext)
  if (!ctx)
    throw new Error('useActionPanel must be used within ActionPanelProvider')
  return ctx
}
